import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AlertService } from "@app/modules/alert";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";


import {
    WorkRequest,
    WorkRequestAuditView,
    IWorkRequestQueryOptions,
    UserStatus
} from "@app-models/work-request";
import { PagingOpts } from "@app/models/common";
import { BaseService } from "./base.service";
import { GlobalConstants } from "@app/utils/global-constants";
import { ApplicationInsightsLoggingService } from "./application-insights-logging.service";
import { AzureUser } from "@app/models/azure-user";
import { getCurrentUserFromStorage } from "@app/utils/storage-utils";
import { WafEncoderService } from "./waf-encoder.service";

@Injectable({
    providedIn: "root",
})
export class WorkRequestService extends BaseService  {
   // url = protectedResources.apiUrl.endpoint + "workrequest/";
    url = this.getBaseURL() + "workrequest/";
    currentUser: AzureUser;
    errorOptions = {
        autoClose: false,
        keepAfterRouteChange: false,
    };
    constructor(private http: HttpClient, 
        private alertService: AlertService,
        private applicationInsightsLoggingService: ApplicationInsightsLoggingService,
        private wafEncoder: WafEncoderService) {
        super();
    }

    //TODO: why do I have all these different getWorkRequest list optioms. I should use mode like i did with byID

    getWorkRequestList(mode: string, pagingOpts: PagingOpts, opts: IWorkRequestQueryOptions) {
        const url = this.getUrl(this.url + mode, pagingOpts, opts);
        return this.http.get<WorkRequest[]>(url.nextUrl , {headers: this.setCustomRequestheaders(),params: url.params} ).pipe(
            catchError(
                (error, caught: Observable<any>): Observable<any> => {
                    console.error("There was an error!", error.message);
                    this.alertService.error(
                        "Error loading data : " +
                            this.checkStatusCode(error),
                        this.errorOptions,
                        error
                    );
                    throw error;
                }
            )
        );
    }

    /*
    getWorkRequests(pagingOpts: PagingOpts, opts: IWorkRequestQueryOptions) {
        const url = this.getUrl(this.url , pagingOpts, opts);
        return this.http.get<WorkRequest[]>(url.nextUrl , {headers: this.setCustomRequestheaders(),params: url.params} ).pipe(
            catchError(
                (error, caught: Observable<any>): Observable<any> => {
                    //this.errorMessage = error.message;
                    console.error("There was an error!", error.message);
                    this.alertService.error(
                        "Error loading data : " +
                            this.checkStatusCode(error),
                        this.errorOptions,
                        error
                    );
                   // this.applicationInsightsLoggingService.logException(error,1);

                    // after handling error, return a new observable
                    // that doesn't emit any values and completes
                    //return of();
                    throw error;
                }
            )
        );
    }
        */
    getProjects(mode: string, pagingOpts: PagingOpts, opts: IWorkRequestQueryOptions) {
        let url = this.getUrl(this.url + "project", pagingOpts, opts);
        if (mode == GlobalConstants.REQUEST_FORM_MODE_RESTRICTED_PROJECT) {
            url = this.getUrl(this.url + "project/restricted", pagingOpts, opts);
        }
        //const url = this.getUrl(this.url + "project", pagingOpts, opts);
        return this.http.get<WorkRequest[]>(url.nextUrl , {headers: this.setCustomRequestheaders(),params: url.params} ).pipe(
            catchError(
                (error, caught: Observable<any>): Observable<any> => {
                    //this.errorMessage = error.message;
                    console.error("There was an error!", error.message);
                    this.alertService.error(
                        "Error loading data : " +
                            this.checkStatusCode(error),
                        this.errorOptions,
                        error
                    );
                   // this.applicationInsightsLoggingService.logException(error,1);

                    // after handling error, return a new observable
                    // that doesn't emit any values and completes
                    //return of();
                    throw error;
                }
            )
        );
    }

    /*
    getWorkRequestsUser(pagingOpts: PagingOpts, opts: IWorkRequestQueryOptions) {
        const url = this.getUrl(this.url + "user", pagingOpts, opts);


        return this.http.get<WorkRequest[]>(url.nextUrl , {headers: this.setCustomRequestheaders(), params: url.params}).pipe(
            catchError(
                (error, caught: Observable<any>): Observable<any> => {
                    console.error("There was an error!", error.message);
                    this.alertService.error(
                        "Error loading data : " +
                            this.checkStatusCode(error),
                        this.errorOptions,
                        error
                    );
                    //this.applicationInsightsLoggingService.logException(error,1);

                    throw error;
                    //return of();
                }
            )
        );
    }
    getWorkRequestsPM(pagingOpts: PagingOpts, opts: IWorkRequestQueryOptions) {
        const url = this.getUrl(this.url + "pm", pagingOpts, opts);
        return this.http.get<WorkRequest[]>(url.nextUrl , {headers: this.setCustomRequestheaders(),params: url.params}).pipe(
            catchError(
                (error, caught: Observable<any>): Observable<any> => {
                    console.error("There was an error!", error.message);
                    this.alertService.error(
                        "Error loading data : " +
                            this.checkStatusCode(error),
                        this.errorOptions,
                        error
                    );
                    //this.applicationInsightsLoggingService.logException(error,1);

                    throw error;
                    //return of();
                }
            )
        );
    }
    getWorkRequestsSponsored(pagingOpts: PagingOpts, opts: IWorkRequestQueryOptions) {
        const url = this.getUrl(this.url + "sponsored", pagingOpts, opts);
        return this.http.get<WorkRequest[]>(url.nextUrl , {headers: this.setCustomRequestheaders(), params: url.params}).pipe(
            catchError(
                (error, caught: Observable<any>): Observable<any> => {
                    console.error("There was an error!", error.message);
                    this.alertService.error(
                        "Error loading data : " +
                            this.checkStatusCode(error),
                        this.errorOptions,
                        error
                    );
                    //this.applicationInsightsLoggingService.logException(error,1);

                    throw error;
                    //return of();
                }
            )
        );
    }
        */
    setWorkRequestStatus(id: number, status: string) {
        return this.http.put(this.url  + "admin/status/"  + id + "?status=" + status,'');
    }

    getWorkRequest(id: number, mode: string) {
        if (mode === GlobalConstants.REQUEST_FORM_MODE_ADMIN || mode === GlobalConstants.REQUEST_FORM_MODE_READ_ONLY) {
            mode = "";
        }
        //if (mode === GlobalConstants.REQUEST_FORM_MODE_RESTRICTED_PROJECT) {
        //    mode = "project/restricted"
        //}
        return this.http.get<WorkRequest>(this.url  + mode + (mode != "" ? "/" : "") + id, {headers: this.setCustomRequestheaders()});
    }

    getWorkRequestAccess(id: number) {
        return this.http.get<string[]>(this.url   + id + "/access", {headers: this.setCustomRequestheaders()});
    }
    getWorkRequestAuditLog(id: number) {
        return this.http.get<WorkRequestAuditView[]>(
            this.url  + id + "/auditlog"
            , {headers: this.setCustomRequestheaders()});
    }

    postWorkRequest(workRequest: WorkRequest) {
        // Encode HTML entities to bypass WAF rule 933210
        const encoded = this.wafEncoder.encodeWorkRequest(workRequest);
        
        return this.http.post<WorkRequest>(this.url, encoded, {headers: this.setCustomRequestheaders()}).pipe(
            catchError(
                (error, caught: Observable<any>): Observable<any> => {
                    this.alertService.error(
                        "Error posting data : " +
                            this.checkStatusCode(error),
                        this.errorOptions,
                        error
                    );
                    //this.applicationInsightsLoggingService.logException(error,1);

                    //rethrow the error to get the response. you could argue in those situations when I need the reponse
                    // on the error, I don't need catch error.
                    throw error;
                }
            )
        );
    }

    deleteWorkRequest(id: number) {
        return this.http.delete(this.url   + "user/" + id, {headers: this.setCustomRequestheaders()}).pipe(
            catchError(
                (error, caught: Observable<any>): Observable<any> => {
                    this.alertService.error(
                        "Error deleting data : " +
                            this.checkStatusCode(error),
                        this.errorOptions,
                        error
                    );
                    //this.applicationInsightsLoggingService.logException(error,1);

                    throw error;
                    //return of();
                }
            )
        );
    }
    deleteWorkRequestAdmin(id: number) {
        return this.http.delete(this.url  + "admin/" + id, {headers: this.setCustomRequestheaders()}).pipe(
            catchError(
                (error, caught: Observable<any>): Observable<any> => {
                    this.alertService.error(
                        "Error deleting data : " +
                            this.checkStatusCode(error),
                        this.errorOptions,
                        error
                    );
                    //this.applicationInsightsLoggingService.logException(error,1);

                    throw error;
                    //return of();
                }
            )
        );
    }
    updateWorkRequest(workRequest: WorkRequest) {
        // Encode HTML entities to bypass WAF rule 933210
        const encoded = this.wafEncoder.encodeWorkRequest(workRequest);
        
        return this.http
            .put<WorkRequest>(this.url + "user/" + workRequest.workRequestId, encoded, {headers: this.setCustomRequestheaders()})
            .pipe(
                catchError(
                    (error, caught: Observable<any>): Observable<any> => {
                        this.alertService.error(
                            "Error updating data :" +
                                this.checkStatusCode(error),
                            this.errorOptions,
                            error
                        );
                        //this.applicationInsightsLoggingService.logException(error,1);
                        throw error;
                        //return of();
                    }
                )
            );
    }

    updateWorkRequestPM(workRequest: WorkRequest) {
        // Encode HTML entities to bypass WAF rule 933210
        const encoded = this.wafEncoder.encodeWorkRequest(workRequest);
        
        return this.http
            .put<WorkRequest>(this.url + "pm/" + workRequest.workRequestId, encoded, {headers: this.setCustomRequestheaders()})
            .pipe(
                map(response => this.wafEncoder.decodeWorkRequest(response)),
                catchError(
                    (error, caught: Observable<any>): Observable<any> => {
                        this.alertService.error(
                            "Error updating data :" +
                                this.checkStatusCode(error),
                            this.errorOptions,
                            error
                        );
                        //sthis.applicationInsightsLoggingService.logException(error,1);
                        throw error;
                        //return of();
                    }
                )
            );
    }
   updateWorkRequestAdmin(workRequest: WorkRequest, sendStatusEmail: boolean) {
        // Encode HTML entities to bypass WAF rule 933210
        const encoded = this.wafEncoder.encodeWorkRequest(workRequest);
        
        return this.http
            .put<WorkRequest>(this.url + "admin/" + workRequest.workRequestId + "?sendStatusEmail=" + sendStatusEmail, encoded, {headers: this.setCustomRequestheaders()})
            .pipe(
                map(response => this.wafEncoder.decodeWorkRequest(response)),
                catchError(
                    (error, caught: Observable<any>): Observable<any> => {
                        this.alertService.error(
                            "Error updating data :" +
                                this.checkStatusCode(error),
                            this.errorOptions,
                            error
                        );
                        //this.applicationInsightsLoggingService.logException(error,1);
                        throw error;
                        //return of();
                    }
                )
            );
    }

    /*
    submitWorkRequest(workRequest: WorkRequest) {
        return this.http
            .put<WorkRequestPOST>(
                this.url + "/" + workRequest.workRequestId + "/submit",
                workRequest
            )
            .pipe(
                catchError(
                    (error: any, caught: Observable<any>): Observable<any> => {
                        console.error("Error posting request: ", error.message);
                        this.alertService.error(
                            this.checkStatusCode(error),
                            this.errorOptions
                        );
                        throw error;
                        //return of();
                    }
                )
            );
    }
    */
    
    /*
    closeWorkRequest(workRequest: WorkRequest)  {
        return this.http
            .put<WorkRequest>(
                this.url + "/" + workRequest.workRequestId + "/close",
                workRequest
            )
            .pipe(
                catchError(
                    (error: any, caught: Observable<any>): Observable<any> => {
                        //const msg = "Error updating data in database.";

                        this.alertService.error(
                            this.checkStatusCode(error),
                            this.errorOptions
                        );
                        throw error;
                    }
                )
            );
    }
    */



    getUserStatus() {
        return this.http.get<UserStatus>(this.url + "userstatus", {headers: this.setCustomRequestheaders()}).pipe(
            catchError(
                (resp, caught: Observable<any>): Observable<any> => {
                    if (resp.headers.get('WWW-Authenticate').indexOf("invalid_token") > -1) {
                        this.alertService.error( "Authentication token is invalid. Please log out and back in", this.errorOptions, resp);
                        
                    } else {
                        let msg = "Can't determine if user is a PM. The error may be transient, please refresh and try again. Consider logging out and back in.";
                        this.alertService.error( msg, this.errorOptions, resp);
                    }
                    throw resp;
                }
            )
        );
    } 

    /*

    isUserPM() {
        this.currentUser = getCurrentUserFromStorage();

        return this.http.get<WorkRequest[]>(this.url + "ispm", {headers: this.setCustomRequestheaders()}).pipe(
            catchError(
                (resp, caught: Observable<any>): Observable<any> => {
                    if (resp.headers.get('WWW-Authenticate').indexOf("invalid_token") > -1) {
                        this.alertService.error( "Authentication token is invalid. Please log out and back in", this.errorOptions, resp);
                        
                    } else {
                        let msg = "A call to the backend system failed. The error may be transient, please refresh and try again. Consider logging out and back in.";
                        this.alertService.error( msg, this.errorOptions, resp);
                    }
                    //this.applicationInsightsLoggingService.logException(error,1);
                    throw resp;
                }
            )
        );
    }
            
    getRestrictedProjectCounts() {

        return this.http.get<number>(this.url + "project/restricted/active", {headers: this.setCustomRequestheaders()}).pipe(
            catchError(
                (resp, caught: Observable<any>): Observable<any> => {
                    if (resp.headers.get('WWW-Authenticate').indexOf("invalid_token") > -1) {
                        this.alertService.error( "Authentication token is invalid. Please log out and back in", this.errorOptions, resp);
                        
                    } else {
                        let msg = "Can't determine if user is a PM. The error may be transient, please refresh and try again. Consider logging out and back in.";
                        this.alertService.error( msg, this.errorOptions, resp);
                    }
                    throw resp;
                }
            )
        );
    } 

    isUserRestrictedPM() {
        this.currentUser = getCurrentUserFromStorage();

        return this.http.get<WorkRequest[]>(this.url + "isrestrictedpm", {headers: this.setCustomRequestheaders()}).pipe(
            catchError(
                (resp, caught: Observable<any>): Observable<any> => {
                    if (resp.headers.get('WWW-Authenticate').indexOf("invalid_token") > -1) {
                        this.alertService.error( "Authentication token is invalid. Please log out and back in", this.errorOptions, resp);
                        
                    } else {
                        let msg = "Can't determine if user is a PM. The error may be transient, please refresh and try again. Consider logging out and back in.";
                        this.alertService.error( msg, this.errorOptions, resp);
                    }
                    //this.applicationInsightsLoggingService.logException(error,1);
                    throw resp;
                }
            )
        );
    }    
    isUserSponsor() {
        this.currentUser = getCurrentUserFromStorage();

        return this.http.get<WorkRequest[]>(this.url + "issponsor", {headers: this.setCustomRequestheaders()}).pipe(
            catchError(
                (error, caught: Observable<any>): Observable<any> => {
                    let msg = "Can't determine if user is a Sponsor. The error may be transient, please refresh and try again.";
                    this.alertService.error(msg, this.errorOptions, error);
                    //this.applicationInsightsLoggingService.logException(error,2);
                    throw error;
                    //return of();
                }
            )
        );
    }   
    */
}
